<template>
  <div class="carousel-slide" :style="{ padding: `0 ${padding}px` }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'slide',
  data() {
    return {
      width: null,
      padding: this.$parent.slidePadding,
    };
  },
};
</script>
